module.exports = __webpack_public_path__ + "assets/img/phone4.9c6d949d.png";